import React from 'react';
import {
    Pagination,
    PaginationContent,
    PaginationItem,
    PaginationNext,
    PaginationPrevious,
} from 'components/shadcn/ui/pagination';

export const TablePagination = ({
    currentPage,
    setCurrentPage,
    pageSize,
    totalItems,
}) => {
    const totalPages = Math.ceil(totalItems / pageSize);

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1); // Increment page number only if it's not the last page
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1); // Decrement page number
        }
    };

    if (!totalPages || totalPages === 0) {
        return null;
    }

    return (
        <Pagination className="p-5 sm:justify-end">
            <PaginationContent>
                <PaginationItem>
                    <PaginationPrevious
                        onClick={handlePrevious}
                        disabled={currentPage === 1}
                        className="border border-slate-200 px-2"
                    />
                </PaginationItem>
                <PaginationItem>
                    <p className="px-2 text-base text-primary-foreground">
                        page {currentPage} out of {totalPages}
                    </p>
                </PaginationItem>
                <PaginationItem>
                    <PaginationNext
                        onClick={handleNext}
                        disabled={currentPage === totalPages}
                        className="border border-slate-200 px-2"
                    />
                </PaginationItem>
            </PaginationContent>
        </Pagination>
    );
};
